import { Component, OnInit } from '@angular/core';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { SystemContactUtilityService } from 'src/app/system/utility/system-contact-utility.service';
import { SystemVariables } from '../../services/external-settings/external-settings.interface';


@Component({
    selector: 'app-address-contacts',
    templateUrl: './address-contacts.component.html',
    styleUrls: ['./address-contacts.component.less'],
    standalone: false
})
export class AddressContactsComponent implements OnInit {

  SysContactUtilSrv = SystemContactUtilityService;
  sysVar!: SystemVariables;

  constructor(private srvES: ExternalSettingsService) {}

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((value) => {
      this.sysVar = value.systemVariables;
    });
  }
}
